module.exports = __webpack_public_path__ + "media/app/assets/logo-cf388d8d3e003f77c0e2e57a86c74912.png";